import { useEffect, useState } from "react";
import api from "@/lib/api";
import { BellRing, Mail, Phone } from "lucide-react";

export default function NotificationsPanel() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/notifications").then((r) => setItems(r.data)); }, []);
  if (items.length === 0) return null;
  return (
    <section data-testid="notifications-panel" className="mt-10">
      <div className="flex items-center gap-2 mb-3">
        <BellRing className="w-6 h-6 text-[#D96B43]" />
        <h2 className="text-2xl font-display font-bold text-slate-900">Family notifications sent</h2>
      </div>
      <p className="text-slate-600 mb-4">Messages we sent to your emergency contact. <span className="text-[#A9741A]">(Simulated for the demo — no real email/SMS delivered yet.)</span></p>
      <div className="bg-white border border-[#E2D9CE] rounded-2xl divide-y divide-[#E2D9CE]">
        {items.map((n) => (
          <div key={n.id} data-testid={`notification-${n.id}`} className="p-4">
            <div className="flex flex-wrap items-center justify-between gap-2">
              <p className="font-semibold text-slate-900">{n.subject}</p>
              <span className="text-sm text-slate-500">{new Date(n.created_at).toLocaleString()}</span>
            </div>
            <p className="text-slate-700 mt-1">{n.body}</p>
            <p className="flex items-center gap-1 text-sm text-slate-500 mt-2">
              {n.channel === "email" ? <Mail className="w-4 h-4" /> : <Phone className="w-4 h-4" />}
              To {n.contact_name} · {n.contact_email || n.contact_phone}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
